import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { FormattedMessage } from '@flipster/i18n';
import { Modal } from '@flipster/react/design-system/modal';
import { stack } from '@flipster/styled-system/patterns';
import { ProfileEvent } from '@flipster/utils/segment/events/profile';

import { SegmentPage } from '../../../../misc/segment/segment-page';
import { editProfileActionBunja, editProfileBunja } from '../bunja';
import { ProfileImage } from './section/1-profile-image';
import { Username } from './section/2-username';
import { Intro } from './section/3-intro';
import { SocialLink } from './section/4-social-link';

interface EditProfileFormProps {
  onSubmit: () => void;
}
export const EditProfileForm = ({ onSubmit }: EditProfileFormProps) => {
  const { pristineAtom, validationAtom, initialSocialConnectionSegmentAtom } = useBunja(editProfileBunja);
  const { isProfileUpdatePendingAtom } = useBunja(editProfileActionBunja);

  const pristine = useAtomValue(pristineAtom);
  const valid = useAtomValue(validationAtom);
  const initialContext = useAtomValue(initialSocialConnectionSegmentAtom);
  const isProfileUpdatePending = useAtomValue(isProfileUpdatePendingAtom);
  return (
    <>
      <SegmentPage name={ProfileEvent.EditProfilePageView} context={initialContext} />
      <Modal.Header>
        <Modal.Title label={<FormattedMessage id='Copy.r251107.Edit_profile' />} />
      </Modal.Header>
      <Modal.Content>
        <section className={stack({ gap: 40 })}>
          <ProfileImage />
          <Username />
          <Intro />
          <SocialLink />
        </section>
      </Modal.Content>
      <Modal.Footer>
        <Modal.Button
          label={<FormattedMessage id='Common.r251107.Save' />}
          size='large'
          isLoading={isProfileUpdatePending}
          disabled={pristine || !valid}
          onClick={onSubmit}
          withSpinner
        />
      </Modal.Footer>
    </>
  );
};
